import EnhancedProductService from "../services/enhanced/EnhancedProductService";
import { bomImagesTransformation } from "../services/enhanced/ImagesUtility";
import CompatibleProductsService from "../services/CompatibleProductsService";
import DOMService from "../services/DOMService";
import { _ } from "vue-underscore";

export default {
  namespaced: true,
  state: {
    isOpen: true,
    bomItemsExist: true,
    bomNoteIsOpen: false,
    bomNoteText: "",
    bomCartButtonsAvailable: true,
    bomPrice: null,
    bomMsrp: null,
    billOfMaterials: {
      SectionHeader: "",
      StatusCode: "",
      BOM: []
    },
    billOfMaterialsParts: {},
    bomImages: {
      LargeSize: [],
      MediumSize: [],
      NormalSize: [],
      Thumbs: []
    },
    isProductFirstLoad: true,
    hasFinishedBeenClicked: false
  },
  getters: {
    getBomPartList: (_state, getters) => {
      if (0 === getters.getBomSourceOfTruth.length) {
        return [];
      }
      return (
        getters.getBomSourceOfTruth
          // we need to remove third party products so they aren't displayed in add to cart modal
          .filter(i => true !== i.IsThirdPartyProduct)
          .map(i => {
            // property of BOM items
            if (i.PartName) {
              return i.PartName;
            }
            // property of billOfMaterialsParts items
            if (i.Value) {
              return i.Value;
            }
          })
      );
    },
    getTotalPrice: (_state, getters) => {
      if (0 === getters.getBomSourceOfTruth.length) {
        return 0;
      }
      return getters.getBomSourceOfTruth
        .map(({ Price, DefaultQuantity }) => {
          const price = null === Price && DefaultQuantity
          ? 0
          : Price.RawPrice * DefaultQuantity;
          return price;
        })
        .reduce((prev, curr) => curr + prev, 0);
    },
    getTotalMSRP: (_state, getters) => {
      if (0 === getters.getBomSourceOfTruth.length) {
        return 0;
      }
      return getters.getBomSourceOfTruth
        .map(({ Price,DefaultQuantity }) => {
          const msrp = null === Price  && DefaultQuantity ? 0 : Price.RawMSRP * DefaultQuantity;
          return msrp;
        })
        .reduce((prev, curr) => curr + prev, 0);
    },
    getIsOpen: state => state.isOpen,
    getBomItemsExist: state => state.bomItemsExist,
    getBomNoteIsOpen: state => state.bomNoteIsOpen,
    getBomNoteText: state => state.bomNoteText,
    getBomCartButtonsAvailable: state => state.bomCartButtonsAvailable,
    // we are using this getter to set local storage
    getEnhancedSuperStateInBom: (state, getters, rootState, rootGetters) =>
      rootGetters["enhancedproduct/getEnhancedSuperState"],
    getBillOfMaterials: state => state.billOfMaterials,
    getBomParts: state => state.billOfMaterialsParts,
    getBomImages: state => {
      return bomImagesTransformation(state.bomImages);
    },
    getBomSourceOfTruth: state => {
      // gets bom items from billOfMaterialsParts object
      const bomParts = state.billOfMaterialsParts;
      const bomPartsKeys = Object.keys(bomParts);
      const bomPartsArray = [];
      bomPartsKeys.forEach(key => bomPartsArray.push(bomParts[key]));

      return [...state.billOfMaterials.BOM, ...bomPartsArray];
    },
    getBomSourceOfTruthWithoutThirdPartyProducts: (_state, getters) => {
      return getters.getBomSourceOfTruth.filter(
        bomItem => true !== bomItem.IsThirdPartyProduct
      );
    },
    getBOMList: (_state, getters) => {
      const bom = getters.getBillOfMaterials.BOM;
      // NOTE: this logic excludes IsProductVariant from the array until user clicks I'm finished button
      const bomListVariantFilteredIfFinishedBtnIsNotClicked = bom.filter(
        item => {
          if (true == getters.hasFinishedBeenClicked) {
            return true;
          }
          return true !== item.IsProductVariant;
        }
      );

      return bomListVariantFilteredIfFinishedBtnIsNotClicked;
    },
    getUserHasSelectedOptions: state => {
      return Object.keys(state.billOfMaterialsParts).length < 1;
    },
    getShowPleaseSelectOptionsMsg: (_state, getters) => {
      if (true == getters.getHasFinishedBeenClicked) {
        return false;
      }
      return getters.getBOMList.length < 1 && getters.getUserHasSelectedOptions;
    },
    getCurrencyCode: (_state, getters) => {
      const noCurrencyCode = "";

      if (0 === getters.getBomSourceOfTruth.length) {
        return noCurrencyCode;
      }
      const currencyCode = getters.getBomSourceOfTruth[0].Price.CurrencyCode;

      if (currencyCode) {
        return currencyCode;
      } else {
        return noCurrencyCode;
      }
    },
    getCurrencySymbol: (_state, getters) => {
      const noCurrencySymbol = "";
      if (0 === getters.getBomSourceOfTruth.length) {
        return noCurrencySymbol;
      } else {
        let maybeFormattedPrice, currencySymbol, isNotPrice;

        for (let i = 0; i < getters.getBomSourceOfTruth.length; i++) {
          maybeFormattedPrice =
            getters.getBomSourceOfTruth[i].Price.FormattedPrice;
          currencySymbol = maybeFormattedPrice.charAt(0);
          // checking if we are getting a string currency
          isNotPrice = isNaN(maybeFormattedPrice.slice(1).replace(",", ""));
          if (false === isNotPrice) {
            return currencySymbol;
          }
        }
        return noCurrencySymbol;
      }
    },
    getIsProductFirstLoad: state => state.isProductFirstLoad,
    getHasFinishedBeenClicked: state => state.hasFinishedBeenClicked,
    getDuplicateParts: state => {
      const parts = _.map(state.billOfMaterialsParts, _.clone);

      const removeDuplicates = Object.values(parts).reduce((acc, curr) => {
        if (acc.some(item => item.Value == curr.Value)) {
          const index = acc.findIndex(part => part.Value === curr.Value);
          const accCopy = [...acc];

          if (index != -1) accCopy[index].DefaultQuantity += 1;

          return accCopy;
        }

        return [...acc, curr];
      }, []);

      return removeDuplicates;
    }
  },
  mutations: {
    TOGGLE_IS_OPEN(state) {
      state.isOpen = !state.isOpen;
    },
    TOGGLE_BOM_ITEMS_EXIST(state) {
      state.bomItemsExist = !state.bomItemsExist;
    },
    UPDATE_BOM_NOTE_IS_OPEN(state) {
      state.bomNoteIsOpen = !state.bomNoteIsOpen;
    },
    UPDATE_BOM_NOTE_TEXT(state, newText) {
      state.bomNoteText = newText;
    },
    UPDATE_BOM_CART_BUTTONS_AVAILABLE(state) {
      state.bomCartButtonsAvailable = !state.bomCartButtonsAvailable;
    },
    ADD_BILL_OF_MATERIALS(state, bom) {
      // add the images from BOM to new object
      if (bom.BOM && bom.BOM.length > 0) {
        bom.BOM.forEach(item => {
          state.billOfMaterials.BOM.push(item);
          if (item.Images != null) {
            if (item.Images.LargeSize != null) {
              const _tmpImages = _.map(state.bomImages.LargeSize, _.clone);
              item.Images.LargeSize.forEach(largeImageItem => {
                _tmpImages.push(largeImageItem);
              });
              this._vm.$set(state.bomImages, "LargeSize", _tmpImages);
            }
            if (item.Images.MediumSize != null) {
              const _tmpImages = _.map(state.bomImages.MediumSize, _.clone);
              item.Images.MediumSize.forEach(mediumImgItem => {
                _tmpImages.push(mediumImgItem);
              });
              this._vm.$set(state.bomImages, "MediumSize", _tmpImages);
            }
            if (item.Images.NormalSize != null) {
              const _tmpImages = _.map(state.bomImages.NormalSize, _.clone);
              item.Images.NormalSize.forEach(normalImgItem => {
                _tmpImages.push(normalImgItem);
              });
              this._vm.$set(state.bomImages, "NormalSize", _tmpImages);
            }
            if (item.Images.Thumbs != null) {
              const _tmpImages = _.map(state.bomImages.Thumbs, _.clone);
              item.Images.Thumbs.forEach(ThumbsImgItem => {
                _tmpImages.push(ThumbsImgItem);
              });
              this._vm.$set(state.bomImages, "Thumbs", _tmpImages);
            }
          }
        });
      }
      state.billOfMaterials.StatusCode = bom.StatusCode;
      state.billOfMaterials.SectionHeader = bom.SectionHeader;
    },
    CLEAR_BILL_OF_MATERIALS(state) {
      this._vm.$set(state.billOfMaterials, "BOM", []);
      this._vm.$set(state.billOfMaterials, "SectionHeader", "");
      this._vm.$set(state.billOfMaterials, "StatusCode", "");
      this._vm.$set(state, "billOfMaterialsParts", {});
    },
    SET_BOM_PARTS(state, bomParts) {
      this._vm.$set(
        state.billOfMaterialsParts,
        bomParts.selectedOption.RulesKey,
        bomParts.selectedOption
      );
    },
    UNSET_BOM_PARTS(state, partsKey) {
      if (state.billOfMaterialsParts && state.billOfMaterialsParts[partsKey]) {
        this._vm.$delete(state.billOfMaterialsParts, partsKey);
      }
    },
    SET_BOM_PARTS_FOR_POSITION(state, bomParts) {
      this._vm.$set(
        state.billOfMaterialsParts,
        bomParts.selectedOption.Value,
        bomParts.selectedOption
      );
    },
    UNSET_BOM_PARTS_FOR_POSITION(state, option) {
      for (const key in state.billOfMaterialsParts) {
        if (
          state.billOfMaterialsParts[key].Position &&
          state.billOfMaterialsParts[key].Position !== null &&
          state.billOfMaterialsParts[key].RulesKey == option.selectedRulesKey
        ) {
          this._vm.$delete(state.billOfMaterialsParts, key);
        }
      }
    },
    MARK_IS_PRODUCT_FIRST_LOAD(state) {
      state.isProductFirstLoad = false;
    },
    UPDATE_HAS_FINISH_BEEN_CLICKED(state, bool) {
      state.hasFinishedBeenClicked = bool;
    },
    RESTORE_BOM_FROM_LOCAL_STORAGE(state, enhancedBom) {
      Object.assign(state, enhancedBom);
    }
  },
  actions: {
    toggleIsOpen({ commit }) {
      commit("TOGGLE_IS_OPEN");
    },
    toggleBomItemsExist({ commit }) {
      commit("TOGGLE_BOM_ITEMS_EXIST");
    },
    toggleBomNoteIsOpen({ commit }) {
      commit("UPDATE_BOM_NOTE_IS_OPEN");
    },
    updateBomNoteText({ commit }, newText) {
      commit("UPDATE_BOM_NOTE_TEXT", newText);
    },
    updateBomCartButtonsAvailable({ commit }) {
      commit("UPDATE_BOM_CART_BUTTONS_AVAILABLE");
    },
    clearBillOfMaterials({ commit }, productData) {
      commit("CLEAR_BILL_OF_MATERIALS");
      CompatibleProductsService.fireProductClearAllEvent(productData);
      CompatibleProductsService.showCompatibleProducts();
      let displaySelectSkuMessage = false;
      displaySelectSkuMessage = productData &&
                                productData.SelectedSku == null && 
                                productData.Series &&
                                !productData.Series.HasCompatibleProducts; 
      DOMService.showHideSelectSkuMsg(displaySelectSkuMessage);
    },
    setBomParts({ commit }, bomParts) {
      commit("SET_BOM_PARTS", bomParts);
    },
    unsetBomParts({ commit }, bomParts) {
      commit("UNSET_BOM_PARTS", bomParts);
    },
    setBomPartsForPosition({ commit }, bomParts) {
      commit("SET_BOM_PARTS_FOR_POSITION", bomParts);
    },
    unsetBomPartsForPosition({ commit }, partsKey) {
      commit("UNSET_BOM_PARTS_FOR_POSITION", partsKey);
    },
    markIsProductFirstLoad({ commit }) {
      commit("MARK_IS_PRODUCT_FIRST_LOAD");
    },
    updatedSectionEnhancedProducBillOfMaterials(
      { commit, dispatch },
      {
        seriesId,
        Configurationid,
        SectionId,
        VariantCode,
        selectedOptions,
        bomParts
      }
    ) {
      EnhancedProductService.fetchBillOFMaterial(
        seriesId,
        Configurationid,
        SectionId,
        VariantCode,
        selectedOptions,
        bomParts
      )
        .then(response => {
          return response.data;
        })
        .then(data => {
          commit("ADD_BILL_OF_MATERIALS", data);
          return data;
        })
        .then(data => {
          if (data.BOM) {
            const sku = data.BOM.filter(d => d.IsPrimaryPart);
            const sitecoreId = sku[0].SitecoreId;
            if (sku && sku[0]) {
              DOMService.hideSelectSkuMsg();
              CompatibleProductsService.fireProductUpdatedEvent(sku[0]);

              dispatch(
                "prodspecification/loadProductSpecification",
                {
                  seriesId: null,
                  skuId: sitecoreId
                },
                {
                  root: true
                }
              );

              dispatch(
                "resources/loadProductResource",
                {
                  seriesId: null,
                  skuId: sitecoreId
                },
                {
                  root: true
                }
              );

              dispatch(
                "enhancedproduct/loadProductTools",
                {
                  seriesId: null,
                  skuId: sitecoreId
                },
                {
                  root: true
                }
              );
            }
          }
          return data;
        });
    },
    updateHasFinishedBeenClicked({ commit }, bool) {
      commit("UPDATE_HAS_FINISH_BEEN_CLICKED", bool);
    },
    restoreBomFromLocalStorage({ commit }, enhancedBom) {
      commit("RESTORE_BOM_FROM_LOCAL_STORAGE", enhancedBom);
    }
  }
};
